export enum PaySupplementAmountType {
  Fixed = 'Fixed',
  Percentage = 'Percentage',
}
